export enum Role {
  Administrator = 0,
  Employee = 1,
  Dia = 2
}



// WEBPACK FOOTER //
// ./src/models/enums/role.enum.ts